import { Link } from "react-router-dom";
import grupoBcLogo from "@/assets/clients/grupo-bc-energia.png";
import flexEnergyLogo from "@/assets/clients/flex-energy.png";
import fcgLogo from "@/assets/clients/fcg-participacoes.png";
import economiaNaEnergiaLogo from "@/assets/clients/economia-na-energia.png";
import nossaEnergiaLogo from "@/assets/clients/nossa-energia.png";
import { ArrowRight, Zap, Target, Heart, Users, Building2, MapPin, BarChart3, Bot } from "lucide-react";
import mapaCobertura from "@/assets/mapa-cobertura-brasil.png";
import dist01 from "@/assets/distribuidoras/dist-01.png";
import dist02 from "@/assets/distribuidoras/dist-02.png";
import dist03 from "@/assets/distribuidoras/dist-03.png";
import dist04 from "@/assets/distribuidoras/dist-04.png";
import dist05 from "@/assets/distribuidoras/dist-05.png";
import dist06 from "@/assets/distribuidoras/dist-06.png";
import dist07 from "@/assets/distribuidoras/dist-07.png";
import dist08 from "@/assets/distribuidoras/dist-08.png";
import dist09 from "@/assets/distribuidoras/dist-09.png";
import dist10 from "@/assets/distribuidoras/dist-10.png";
import dist11 from "@/assets/distribuidoras/dist-11.png";
import dist12 from "@/assets/distribuidoras/dist-12.png";
import { Button } from "@/components/ui/button";
import { Layout } from "@/components/layout/Layout";
import { PageHero } from "@/components/shared/PageHero";
import { CTASection } from "@/components/shared/CTASection";
import { Card, CardContent } from "@/components/ui/card";

const values = [
  {
    icon: Zap,
    title: "Simplicidade",
    description: "Acreditamos que tecnologia deve simplificar, não complicar. Cada feature é pensada para eliminar trabalho, não criar mais.",
    color: "from-amber-500 to-orange-500",
  },
  {
    icon: Target,
    title: "Foco no resultado",
    description: "Não medimos sucesso por features entregues, mas por horas economizadas e erros evitados para nossos clientes.",
    color: "from-blue-500 to-cyan-500",
  },
  {
    icon: Heart,
    title: "Transparência",
    description: "Operamos com dados sensíveis de negócios. A confiança é construída com transparência total em tudo que fazemos.",
    color: "from-pink-500 to-rose-500",
  },
  {
    icon: Users,
    title: "Parceria",
    description: "Não somos fornecedores, somos parceiros. O sucesso do seu negócio de energia é o nosso sucesso.",
    color: "from-emerald-500 to-teal-500",
  },
];

const teamPlaceholders = [
  { role: "CEO & Co-founder", department: "Liderança" },
  { role: "CTO & Co-founder", department: "Tecnologia" },
  { role: "Head de Produto", department: "Produto" },
  { role: "Head de Customer Success", department: "Operações" },
  { role: "Head de Vendas", department: "Comercial" },
  { role: "Head de Engenharia", department: "Tecnologia" },
];

const distribuidoraLogos = [
  dist01, dist02, dist03, dist04, dist05, dist06,
  dist07, dist08, dist09, dist10, dist11, dist12,
];

export default function Empresa() {
  return (
    <Layout>
      <PageHero
        title="Sobre a Cogni"
        subtitle="Com mais de 12 anos de experiência no mercado de energia, trabalhamos lado a lado com nossos clientes e parceiros na construção da solução mais completa de gestão de crédito de energia."
      />

      {/* Prova social / números */}
      <section className="py-8 sm:py-12 border-b border-border bg-muted/30">
        <div className="container-wide">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 max-w-4xl mx-auto text-center">
            <div className="p-4 sm:p-6">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-3">
                <BarChart3 className="h-6 w-6 text-primary" />
              </div>
              <div className="text-2xl sm:text-3xl font-bold mb-1">12+</div>
              <p className="text-muted-foreground text-sm">Anos no mercado de energia</p>
            </div>
            <div className="p-4 sm:p-6">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-3">
                <Bot className="h-6 w-6 text-primary" />
              </div>
              <div className="text-2xl sm:text-3xl font-bold mb-1">30.000+</div>
              <p className="text-muted-foreground text-sm">Faturas processadas por mês</p>
            </div>
            <div className="p-4 sm:p-6">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-3">
                <MapPin className="h-6 w-6 text-primary" />
              </div>
              <div className="text-2xl sm:text-3xl font-bold mb-1">19</div>
              <p className="text-muted-foreground text-sm">Estados com robôs de download ativos</p>
            </div>
          </div>
        </div>
      </section>

      {/* Logos de clientes */}
      <section className="py-6 sm:py-8 border-b border-border">
        <div className="container-wide">
          <p className="text-center text-xs sm:text-sm text-muted-foreground mb-4">Empresas que confiam na Cogni</p>
          <div className="flex flex-wrap items-center justify-center gap-8 sm:gap-12">
            {[grupoBcLogo, flexEnergyLogo, fcgLogo, economiaNaEnergiaLogo, nossaEnergiaLogo].map((logo, i) => (
              <div key={i} className="h-8 sm:h-10 flex items-center justify-center">
                <img src={logo} alt="Logo cliente" className="h-full w-auto object-contain opacity-70 hover:opacity-100 transition-opacity" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="section-padding section-alt">
        <div className="container-narrow">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <span className="inline-block px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
                Nossa missão
              </span>
              <h2 className="text-headline font-bold mb-4 sm:mb-6">
                Nossa visão
              </h2>
              <p className="text-muted-foreground mb-4 text-sm sm:text-base lg:text-lg">
                A gestão de créditos de energia envolve uma operação naturalmente complexa. 
                Na prática, muitas operações ainda dependem de planilhas, controles paralelos, 
                processos manuais e conhecimento concentrado em poucas pessoas.
              </p>
              <p className="text-muted-foreground mb-6 text-sm sm:text-base lg:text-lg">
                A Cogni foi desenhada para atacar esse núcleo do problema: transformar uma 
                operação fragmentada em uma centralizada, padronizada e governável, reduzir 
                riscos e inadimplências e dar mais previsibilidade para a gestão.
              </p>
              <div className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 bg-gradient-to-r from-primary/10 to-accent/10 rounded-xl border border-primary/20">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gradient-to-br from-primary to-accent flex items-center justify-center flex-shrink-0">
                  <Zap className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
                </div>
                <span className="text-base sm:text-lg font-medium">always on.</span>
              </div>
            </div>
            <div className="bg-gradient-to-br from-primary/10 to-accent/10 border border-border rounded-xl sm:rounded-2xl p-6 sm:p-8 h-56 sm:h-80 flex items-center justify-center">
              <span className="text-muted-foreground text-sm">[Imagem/ilustração da equipe ou escritório]</span>
            </div>
          </div>
        </div>
      </section>

      {/* Distribuidoras atendidas */}
      <section className="section-padding">
        <div className="container-wide">
          <div className="text-center mb-8 sm:mb-10">
            <h2 className="text-headline font-bold mb-4">Distribuidoras atendidas</h2>
            <p className="text-body-lg text-muted-foreground max-w-2xl mx-auto">
              Temos robôs de download e processamento automático de faturas nos 19 estados onde nossos clientes operam.
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-8 max-w-4xl mx-auto">
            {distribuidoraLogos.map((logo, i) => (
              <div key={i} className="h-10 sm:h-12 flex items-center justify-center">
                <img src={logo} alt="Logo distribuidora" className="h-full w-auto object-contain opacity-70 hover:opacity-100 transition-opacity" />
              </div>
            ))}
          </div>
          <div className="mt-8 text-center">
            <img src={mapaCobertura} alt="Mapa de cobertura das distribuidoras atendidas pela Cogni no Brasil" className="max-w-xs sm:max-w-sm md:max-w-md mx-auto" />
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section-padding section-gradient-purple relative overflow-hidden">
        <div className="absolute top-0 left-0 w-60 sm:w-80 h-60 sm:h-80 bg-white/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-48 sm:w-64 h-48 sm:h-64 bg-white/5 rounded-full blur-3xl" />
        <div className="container-wide relative z-10">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-headline font-bold mb-4">
              Nossos valores
            </h2>
            <p className="text-body-lg text-muted-foreground max-w-2xl mx-auto">
              Os princípios que guiam como construímos produto e atendemos clientes.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {values.map((value, index) => (
              <Card key={index} className="bg-background/80 backdrop-blur-sm border-border text-center shadow-lg hover:shadow-xl transition-shadow">
                <CardContent className="pt-6 sm:pt-8 pb-5 sm:pb-6 px-4 sm:px-6">
                  <div className={`w-12 h-12 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl bg-gradient-to-br ${value.color} flex items-center justify-center mx-auto mb-3 sm:mb-4 shadow-lg`}>
                    <value.icon className="h-6 w-6 sm:h-8 sm:w-8 text-white" />
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold mb-2">{value.title}</h3>
                  <p className="text-muted-foreground text-xs sm:text-sm">{value.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section-padding section-warm">
        <div className="container-wide">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-headline font-bold mb-4">
              Nosso time
            </h2>
            <p className="text-body-lg text-muted-foreground max-w-2xl mx-auto">
              Pessoas apaixonadas por resolver problemas complexos com soluções simples.
            </p>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {teamPlaceholders.map((member, index) => (
              <Card key={index} className="border-border shadow-lg hover:shadow-xl transition-shadow">
                <CardContent className="p-4 sm:p-6">
                  <div className="w-14 h-14 sm:w-20 sm:h-20 rounded-full bg-gradient-to-br from-primary/20 to-accent/20 flex items-center justify-center mx-auto mb-3 sm:mb-4">
                    <Users className="h-6 w-6 sm:h-8 sm:w-8 text-primary" />
                  </div>
                  <div className="text-center">
                    <h3 className="font-semibold text-sm sm:text-lg mb-1">[Nome]</h3>
                    <p className="text-primary text-xs sm:text-sm font-medium">{member.role}</p>
                    <p className="text-muted-foreground text-xs sm:text-sm">{member.department}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
          <div className="text-center mt-6 sm:mt-8">
            <p className="text-muted-foreground mb-4 text-sm">
              Quer fazer parte do time?
            </p>
            <Link to="/contato">
              <Button variant="outline" className="border-2 touch-target">
                Ver vagas abertas
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="section-padding section-gradient-blue relative overflow-hidden">
        <div className="absolute top-0 right-0 w-60 sm:w-80 h-60 sm:h-80 bg-white/5 rounded-full blur-3xl" />
        <div className="container-narrow text-center relative z-10">
          <h2 className="text-headline font-bold mb-4">
            Entre em contato
          </h2>
          <p className="text-body-lg text-muted-foreground mb-6 sm:mb-8">
            Estamos sempre disponíveis para conversar sobre seu projeto de energia.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
            <div className="bg-background/60 backdrop-blur-sm rounded-xl sm:rounded-2xl border border-border p-5 sm:p-6 shadow-lg">
              <h3 className="font-semibold mb-2 text-sm sm:text-base">E-mail</h3>
              <p className="text-muted-foreground text-xs sm:text-sm">contato@cogni.com.br</p>
            </div>
            <div className="bg-background/60 backdrop-blur-sm rounded-xl sm:rounded-2xl border border-border p-5 sm:p-6 shadow-lg">
              <h3 className="font-semibold mb-2 text-sm sm:text-base">Telefone</h3>
              <p className="text-muted-foreground text-xs sm:text-sm">+55 (11) 0000-0000</p>
            </div>
            <div className="bg-background/60 backdrop-blur-sm rounded-xl sm:rounded-2xl border border-border p-5 sm:p-6 shadow-lg">
              <h3 className="font-semibold mb-2 text-sm sm:text-base">Localização</h3>
              <p className="text-muted-foreground text-xs sm:text-sm">São Paulo, SP - Brasil</p>
            </div>
          </div>
        </div>
      </section>

      <CTASection
        variant="dark"
        title="Vamos conversar?"
        subtitle="Agende uma demonstração e conheça nossa equipe."
      />
    </Layout>
  );
}
